import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import cx from "classnames";
import { useTranslator } from "@jutro/locale";
import { isAccessibleDisabled, muteCallbacks } from "../../../accessibleDisabled";
import { Icon } from "../../Icon/Icon";
import { messages } from "./Checkbox.messages.js";
import styles from "./CheckboxField.module.css";
export var Checkbox = function (_ref) {
  var id = _ref.id,
    checked = _ref.checked,
    label = _ref.label,
    required = _ref.required,
    icon = _ref.icon,
    controlClassName = _ref.controlClassName,
    hideLabel = _ref.hideLabel,
    showInlineLabel = _ref.showInlineLabel,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    disabled = _ref.disabled,
    accessibilityProps = _ref.accessibilityProps,
    dataPathProps = _ref.dataPathProps,
    renderInlineLabel = _ref.renderInlineLabel,
    children = _ref.children,
    detailElement = _ref.detailElement,
    value = _ref.value,
    ariaLabel = _ref["aria-label"],
    testId = _ref.testId,
    checkboxRef = _ref.checkboxRef,
    secondaryLabelId = _ref.secondaryLabelId,
    translator = useTranslator(),
    tabIndex = disabled ? void 0 : 0,
    checkboxElementClasses = cx(styles.checkboxElement, controlClassName),
    accessibleDisabled = disabled && isAccessibleDisabled("accessibleDisabled.fields"),
    checkboxElement = React.createElement("span", _extends({
      onClick: onClick,
      className: checkboxElementClasses,
      "aria-label": ariaLabel || translator(label),
      tabIndex: tabIndex,
      onBlur: onBlur,
      onFocus: onFocus,
      onKeyDown: onKeyDown,
      role: "checkbox",
      "aria-checked": checked,
      ref: checkboxRef,
      "aria-disabled": !!disabled || null,
      "aria-describedby": secondaryLabelId
    }, accessibleDisabled && _objectSpread(_objectSpread({}, muteCallbacks({
      onBlur: onBlur,
      onFocus: onFocus,
      onKeyDown: onKeyDown,
      onClick: onClick
    })), {}, {
      tabIndex: 0,
      "aria-readonly": !0,
      readOnly: !0
    })), checked && React.createElement(Icon, {
      icon: icon,
      className: styles.checkboxIcon,
      size: "small"
    })),
    detailVisible = checked && (children || detailElement),
    detailAriaLabel = translator(messages.details, {
      id: id
    }),
    detail = React.createElement("div", {
      className: cx(_defineProperty({}, styles.detailVisible, detailVisible)),
      role: "region",
      "aria-live": "assertive",
      "aria-label": detailAriaLabel
    }, detailVisible && (children || detailElement)),
    classes = cx(styles.checkbox, {
      disabled: disabled
    });
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes
  }, React.createElement("input", _extends({
    id: id,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    className: styles.input,
    required: required
  }, dataPathProps, accessibilityProps, {
    "data-testid": testId,
    "aria-hidden": "true",
    tabIndex: -1
  }, accessibleDisabled && _objectSpread({
    disabled: void 0,
    "aria-disabled": !0,
    "aria-readonly": !0,
    readOnly: !0
  }, muteCallbacks({
    onChange: onChange
  })))), checkboxElement, !hideLabel && showInlineLabel && renderInlineLabel(styles)), detail);
};
Checkbox.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "Checkbox"
}, Checkbox.__docgenInfo = {
  componentName: "Checkbox",
  packageName: "@jutro/components",
  description: "",
  displayName: "Checkbox",
  methods: [],
  actualName: "Checkbox"
};